import { cancelRequest, createRequestCoordinator, requestsCurrent } from "../core/request-coordinator.js";

export function createWorkspaceContentState() {
  return {
    workspaceID: "",
    refInput: "",
    ref: "",
    commit: "",
    path: "",
    entries: [],
    loadingTree: false,
    treeError: "",
    selectedFilePath: "",
    file: null,
    loadingFile: false,
    fileError: "",
    fileEditing: false,
    fileSaving: false,
    fileDraftContent: null,
    exporting: false,
    fileUploadPath: "",
    fileUploadFile: null,
    fileUploadName: "",
    fileUploadExecutable: false,
    fileUploading: false,
    fileUploadProgress: 0,
    treeUploadPath: "",
    treeUploadFile: null,
    treeUploadName: "",
    treeUploading: false,
    treeUploadProgress: 0,
    deletePath: "",
    deletingPath: false,
    mutationError: "",
    lastChange: null,
    activeMutation: "",
    refInputVisible: false,
    feedbackDismissed: false,
    importFile: null,
    importFileName: "",
    importMessage: "",
    importExpectedBaseCommit: "",
    importing: false,
    importProgress: 0,
    importError: "",
    lastImport: null,
    actionsVisible: false,
    requests: {
      tree: createRequestCoordinator(),
      file: createRequestCoordinator()
    }
  };
}

export function resetWorkspaceContentState(state) {
  cancelWorkspaceContentRequests(state);
  Object.assign(state, createWorkspaceContentState());
}

export function cancelWorkspaceContentRequests(state) {
  if (state?.requests?.tree) {
    cancelRequest(state.requests.tree);
  }
  if (state?.requests?.file) {
    cancelRequest(state.requests.file);
  }
}

export function joinWorkspacePath(basePath, name) {
  const base = String(basePath || "");
  const leaf = String(name || "");
  if (!base) return leaf;
  if (!leaf) return base;
  return `${base}/${leaf}`;
}

export function workspacePathDirname(value) {
  const current = String(value || "");
  if (!current) return "";
  const parts = current.split("/");
  parts.pop();
  return parts.join("/");
}

export function parentWorkspacePath(value) {
  const parts = String(value || "").split("/");
  parts.pop();
  return parts.join("/");
}

export function workspaceBasename(value) {
  const parts = String(value || "").split("/");
  return parts[parts.length - 1] || value || "/";
}

export function resolveWorkspaceFileUploadTarget(panel) {
  const explicit = String(panel.fileUploadPath || "");
  if (explicit) return explicit;
  if (panel.selectedFilePath) return String(panel.selectedFilePath);
  if (panel.fileUploadFile instanceof File) {
    return joinWorkspacePath(panel.path, panel.fileUploadFile.name || "");
  }
  return "";
}

export function resolveWorkspaceTreeUploadTarget(panel) {
  const explicit = String(panel.treeUploadPath || "");
  if (explicit) return explicit;
  return String(panel.path || "");
}

export function resolveWorkspaceDeleteTarget(panel) {
  const explicit = String(panel.deletePath || "");
  if (explicit) return explicit;
  if (panel.selectedFilePath) return String(panel.selectedFilePath);
  return String(panel.path || "");
}

export function workspaceRequestCurrent(state, workspaceID, options = {}) {
  return state.workspaceID === workspaceID && requestsCurrent(options.request);
}
